import request from '@/router/axios';
//查询用户列表(带分页)接口
export const searchUserPage = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/searchUserPage',
    method: 'post',
    data: data
  })
}
//添加用户
export const addUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/addUser',
    method: 'post',
    data: data
  })
}
//修改用户
export const updateUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/updateByUserId',
    method: 'post',
    data: data
  })
}
//删除用户
export const deleteUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/deleteUser',
    method: 'post',
    data: data
  })
}
//查询用户详情
export const searchUserDetail = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/searchUserDetail',
    method: 'post',
    data: data
  })
}
//重置用户密码
export const resetUserPassword = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/resetUserPassword',
    method: 'post',
    data: data
  })
}
//查询用户菜单权限
export const searchUserResources = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/searchUserResources',
    method: 'post',
    data: data
  })
}
//退出用户
export const logout = (data) => {
  return request({
    url: '/svolt-ess-auth-service/system/logout',
    method: 'post',
    data: data
  })
}
//获取验证码
export const sendVerificationCode = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/sendVerificationCode',
    method: 'post',
    data: data
  })
}
//验证码重置用户密码
export const resetUserPasswordWithVerificationCode = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/resetUserPasswordWithVerificationCode',
    method: 'post',
    data: data
  })
}
//修改密码
export const updatePassword = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/updatePassword',
    method: 'post',
    data: data
  })
}
//清理用户操作密码-策略控制安全码
export const clearUserControlPassword = (data) => {
  return request({
    url: '/svolt-ess-service/userControl/clearUserControlPassword',
    method: 'post',
    data: data
  })
}

export default {
  searchUserPage,
  addUser,
  updateUser,
  deleteUser,
  searchUserDetail,
  resetUserPassword,
  searchUserResources,
  logout,
  sendVerificationCode,
  resetUserPasswordWithVerificationCode,
  updatePassword,
  clearUserControlPassword
}



// WEBPACK FOOTER //
// ./src/api/user.js